<script>
import OrdersApi from "@/services/orders-api";
import AvoirRequestApi from "@/services/avoirRequest-api";
import ItemsApi from "@/services/items-api";
import VueBarcode from 'vue-barcode';

export default {

  components: {
     VueBarcode
  },

  props: {
     onClose:{
          type:Function,
          default: null
        }, 
    title:{
          type:String,
          default: ""
        },

        showAddNewAvoirModal:{
          type:Boolean,
          default: false
        },
        isNew:{
          type:Boolean,
          default: false
        },

        propsAvoirId:{
              type:Number,
              default: null
            },

  },

  data() {
    return {
        localShowAddNewAvoirModal: this.showAddNewAvoirModal,

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},

        ordersList: [],
        isTableLoading: false,

        orderSelected:null,
        orderLineSelected:null,
        avoir:{} ,
        avoirLines:{} ,

        start:null ,
        end:null ,
        orderLines: [] ,
        quantityAvoir:0 ,
        confirmedQuantityAvoir:0 ,
        reason:null ,
        avoirRequestId:null ,
        selectedItem: { },
        batchDate:"",
        batchNumber:"",
        showItemsModal:false ,
        itemsFilter: '',
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        isItemsTableBusy: false,
        endOfFindItems:false,
        itemsList: [],
        itemLines: [],
        itemFields: [
        {key:"actions", label:""},
        { key:"ref", label: "Réference", sortable: false, tdClass:"text-left align-middle"},
        { key:"title", label: "Article", sortable: false, tdClass:"text-left font-weight-bold  align-middle"},
        { key:"packageCount", label:"Unités par carton", thClass:"text-right", tdClass:"text-right align-middle", thStyle:"width:150px;"}, 
        { key:"priceTaxIncl", label:"Prix TTC", thClass:"text-right ", tdClass:"text-right font-weight-bold align-middle", thStyle:"width:100px;"}, 
        
        // { key:"price", label: "P.U (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        // { key:"discount", label: "remise (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        // { key:"discountedPrice", label: "P.U.Remisé (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
      ],
        //item:null,
        isAvoirSubmitted: false,

    };
  },

  mounted(){

    this.findItems();
    //this.getOrders()

    var date = new Date();
      
      this.start = new Date(date.getFullYear(), date.getMonth(), 1);
      const startoffset = this.start.getTimezoneOffset()
      this.start= new Date(this.start.getTime() - (startoffset*60*1000))
      this.start=this.start.toISOString().split('T')[0]

      this.end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const endoffset = this.end.getTimezoneOffset()
      this.end= new Date(this.end.getTime() - (endoffset*60*1000))
      this.end=this.end.toISOString().split('T')[0]
  },
  
  computed: {
        role() {
          return this.$cookies.get('userr');
        },
    },

  methods: {
     handlePrint() {
      document.querySelectorAll('.modal-content').forEach(el => {
        el.style.border = '1px dashed #858383';
        el.style.borderRadius = '5px';
      });

      this.$nextTick(() => {
        window.print();
      });
    },

    findItems() {
      
    this.isItemsTableBusy = true;
    this.itemsListTimestamp = new Date().getTime();
    ItemsApi.findItems(this.pagemodelMain.currentPage, this.pagemodelMain.perPage, 
                [], 
                this.itemsFilter, 
                null, null, false, null, null,null,null, null, null,
                null, false,false,false,false,false,false,false,
                this.itemsListTimestamp
                )

      .then(itemsList => {
    
        this.itemLines=itemsList.list ;
        this.pagemodelMain.totalRows = itemsList.total;
        this.pagemodelMain.currentPage = itemsList.page;
        this.pagemodelMain.perPage = itemsList.pageSize;
        this.pagemodelMain.pageSize = itemsList.pageSize;
      })
      .finally(() => {
        this.isItemsTableBusy = false;
        this.endOfFindItems = true;
      });
  },

  addItems(item){

    /*this.orderLineSelected.ref = item.ref;
    this.orderLineSelected.title = item.title;*/

    this.selectedItem = item;

    this.showItemsModal=false

    },

    showitemModal(){
      this.showItemsModal=true;
    },

    onCloseAddNewAvoirModal(){
      this.selectedItem = {};
      this.batchNumber=""
      this.batchDate=""

      this.onClose()

      if(this.role == 0 && this.avoirRequestId ){
        AvoirRequestApi.deleteAvoirRequestIfEmpty(this.avoirRequestId ).then(
          this.onClose()
        )
      }else{
        this.onClose()
      }
      
    }, 

    refusedAvoirRequest(){
      const status = 3 ;
      AvoirRequestApi.addRequestAvoir(this.avoirRequestId  , null , status )
        .then(avoirId => {
            if(avoirId) {
            this.avoirRequestId = avoirId 
            this.onCloseAddNewAvoirModal()
            }
          })
    },

    validateRequest(){
      AvoirRequestApi.validateRequestAvoir(this.avoir )
      .then(()=>{
        this.onCloseAddNewAvoirModal()
            })
    },

    requestAvoirStatusToLabel(status){
      switch(status){
        case 0: return 'Brouillon';
        case 1: return 'Envoyée';
        case 2:return 'Traitée';
        case 3 :return 'Refusée';
        default: return '_'
      }
    },

    requestAvoirToColor(status){
     
      switch(status){
        case 0: return 'secondary';
        case 1: return 'warning';
        case 2:return 'success';
        case 3 :return 'danger';
        default: return '_'
      }
    },

    sendNewAvoir(){
      const status = 1
      // this.showAddNewAvoirModal= true 
          AvoirRequestApi.addRequestAvoir(this.avoirRequestId  , this.reason , status )
        .then(avoirId => {
            if(avoirId) {
              this.avoirRequestId = avoirId
              this.getRequestAvoirById()
              this.isAvoirSubmitted = true;
              // this.onCloseAddNewAvoirModal()
            }
          }) 
        },
 
    addRequestAvoirLine(){
      const lineAvoirRequest = {
                avoirId: this.avoirRequestId  ,
                itemId: this.selectedItem.id,
                quantityAvoir: this.selectedItem.qtyAvoir,
                reason: this.selectedItem.reason,
                batchNumber:this.batchNumber,
                batchDate:this.batchDate,

                /*orderExtId: this.orderSelected.extId,
                orderLineId: this.orderLineSelected ? this.orderLineSelected.id : null,
                quantityAvoir: this.quantityAvoir*/
      };

      AvoirRequestApi.addRequestAvoirLine(lineAvoirRequest )
          .then((avoirId)=>{

            if (avoirId) {
              this.avoirRequestId = avoirId
            this.getRequestAvoirById()
            this.selectedItem = {}
            }

            
                })
    } , 

    removeAvoirLine(line){
        const lineAvoirRequest = {
                    avoirId: this.avoirRequestId,
                    itemId: line.itemId ,
                    quantityAvoir:line.quantityAvoir,
          };
            AvoirRequestApi.deleteAvoirRequestLine(lineAvoirRequest )
            .then(()=>{
                this.getRequestAvoirById()
            } )
            }, 

    getOrderLines(orderId){
      OrdersApi.getOrderLines(orderId).then(
      order => {
          if (order){
          this.orderLines=order.lines
          }}
      )
      },

    getRequestAvoirById(){
      AvoirRequestApi.getRequestAvoirById(this.avoirRequestId  ).then(
        result => {
            if (result){

            this.avoir=result
            this.reason = result.reason
            this.avoirLines =result.lines ?  result.lines : []
            } }
        )},

    getOrders() {
      this.isTableLoading = true
      
      if(this.role==0){
        const status = 3 ;

      OrdersApi.getOrdersByCustomer(this.pagemodel.currentPage, this.pagemodel.perPage,this.supplierId, false,status,this.isCurrent,this.start,this.end, this.channel ,true)
      .then(orders => {
        if(orders){
          this.ordersList =orders.list ;
          this.pagemodel.totalRows = orders.total;
          this.pagemodel.currentPage = orders.page;
          this.pagemodel.perPage = orders.pageSize;
          this.pagemodel.pageSize = orders.pageSize;
        }
      })
      .finally(() => {
        this.isTableLoading=false 
      })
      }
    }, 
    },

    watch: {
     // invoices-list creates this modal only when it opens (v-if), so this must also run on creation:
     // otherwise an existing request opens empty, because its lines are loaded here
     showAddNewAvoirModal: {
      immediate: true,
      handler(isOpen) {
      this.avoirRequestId = this.propsAvoirId
      this.localShowAddNewAvoirModal = isOpen;
      this.orderSelected = null
      if (this.isNew){
        this.reason=null
      }
      this.avoirLines ={}
      if(isOpen && this.avoirRequestId){
        this.getRequestAvoirById(this.avoirRequestId)
      }
      
      },
    }, 

    end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getOrders()
          }   
        },
    start: function(){
        if((this.end && this.start) || (!this.end  && !this.start)  ){
        this.getOrders()
        }
    },

     orderSelected: function(){
        this.orderLineSelected = null;
        if (this.orderSelected){       
            this.getOrderLines(this.orderSelected.id);
            this.quantityAvoir = 0
        }    
    }, 

      orderLineSelected: function(){
        if (this.orderLineSelected){       
            this.quantityAvoir = 0
        }    
      }, 

  },
  
};
</script>

<template>

<b-modal
            v-model="localShowAddNewAvoirModal"
            :title="this.title" 
          
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            size="xl"
            no-close-on-backdrop
            @hide="onCloseAddNewAvoirModal"      
            hide-footer
            >

            <div class="d-none d-print-block mb-4 text-dark">

              <div class="row">
                <div class="col-6">
                  <h3 class="font-weight-bold text-dark">DEMANDE D'AVOIR</h3>
                <span class="font-size-16 text-dark">N° <strong>{{avoir.avoirId}}</strong></span>
                </div>

                <div class="col-6 text-right">
                  <vue-barcode
                    v-if="avoir.avoirId"
                        :value="avoir.avoirId"
                        :width="2"  :height="50" 
                        background="transparent"
                        fontSize="16" >
                      </vue-barcode>

                </div>

              </div>

              


              


              <h5 class="font-weight-bold mt-4 text-dark">CLIENT</h5>
              <span class="text-dark">{{this.avoir.customer}}</span>

              <h5 class="font-weight-bold mt-4 text-dark">DATE</h5>
              <span class="text-dark">{{this.avoir.date}}</span>

              <h5 class="font-weight-bold mt-4 text-dark">NBRE ARTICLES</h5>
              <span class="text-dark">{{this.avoir.avoirLinesCount}}</span>

          </div>

            <div v-if="this.avoir && !isNew " class="mt-2 pl-3 pb-4 font-size-14 d-print-none">
              <div><strong v-if="role==1">{{this.avoir.customer}}</strong> </div>
              <b-badge href="#" :variant="requestAvoirToColor(this.avoir.status)" class="font-size-12 d-print-none">
                {{requestAvoirStatusToLabel(this.avoir.status)}} 
              </b-badge>
            </div>

            <!--div v-if="isNew || (this.role==0 && (avoir.status==0 ||avoir.status==1)) " class="row pt-4">
                <div class="col-md-2 col-xs-12 pr-md-4">
                    <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
                            <b-form-datepicker
                            v-model="start"
                            :locale="$t('datPicker.locale')"
                            :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                            dark
                            reset-button
                            close-button
                            :label-reset-button="$t('datPicker.label-reset-button')"
                            :label-close-button="$t('datPicker.label-close-button')"
                            dropright
                            hide-header
                            >
                            </b-form-datepicker>
                    </b-form-group>
                </div>

                    <div class="col-md-2 col-xs-12 pr-md-4">
                        <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')" label-for="">
                            <b-form-datepicker
                                    v-model="end"
                                    :locale="$t('datPicker.locale')"
                                    :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                                    dark
                                    reset-button
                                    close-button
                                    :label-reset-button="$t('datPicker.label-reset-button')"
                                    :label-close-button="$t('datPicker.label-close-button')"
                                    dropright                         
                                    hide-header
                                    >
                            </b-form-datepicker>
                        </b-form-group>
                    </div>
                </div-->

<!-- start table-->
    <div class="table-responsive" style="overflow:visible;">
        <table class="table">
                <thead>
                   <tr>
                    <th class="text-dark" style="width: 280px;">Article</th>
                    <th class="text-dark" style="width: 150px;">Numéro Lot</th>
                    <th class="text-dark" style="width: 150px;">Date Lot</th>
                    <th  style="width: 200px;" class="text-left text-dark">Quantité Avoir</th>
                    <th style="width: 400px;" class="text-left text-dark">Motif de la demande</th>
                    <!-- <th v-if="this.role==1 || (avoir.status==2 ||avoir.status==3) " style="width: 170px;" class="text-left">Quantité Confirmée</th> -->
                    <th style="width:50px;"></th>
                  </tr>
                </thead>
          <tbody>

              <tr v-if="(isNew && !isAvoirSubmitted) || (this.role==0 && avoir.status==0) " class="d-print-none" >

                  <!-- Select item -->
                  <td class="pt-4 pb-4">
                    <div class="row " >
                      <b-form-input placeholder="Sélectionner un article"  class="col-11 text-dark font-weight-bold "  :value="selectedItem.ref && selectedItem.title ? selectedItem.ref + ' - ' + selectedItem.title : ''"  disabled></b-form-input> 
                      <i class="col-1 fas fa-pencil-alt font-size-18 text-primary align-middle pl-3 pt-2" style="cursor:pointer ;" @click="showitemModal() ;findItems()"></i>
                    </div>
                  </td>

                  <td class="pt-4 pb-4">
                    <div>
                        <b-input
                            id="numberInput"
                            type="text"
                            class="form-control text-dark font-size-16 font-weight-normal bg-white"
                            style="height:33px;"
                            v-model="batchNumber"
                            placeholder="N° Lot"
                        />
                    </div>    
                </td>
                

                  <td class="pt-4 pb-4">
                          <b-form-datepicker
                          v-model="batchDate"
                          :locale="$t('datPicker.locale')"
                          :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                          dark
                          reset-button
                          close-button
                          :label-reset-button="$t('datPicker.label-reset-button')"
                          :label-close-button="$t('datPicker.label-close-button')"
                          dropright
                          hide-header
                          ></b-form-datepicker>
                      </td>

                 

                  

                 
                  <td class="pt-4 pb-4">
                        <div>
                        <b-input
                        id="quantityInput"
                        type="number"
                        class="form-control text-dark font-size-16 font-weight-normal bg-white"
                        style="height:33px;"
                        v-model="selectedItem.qtyAvoir"
                        placeholder="Qté"
                        />
                        </div>    
                    </td>

                    <td class="pt-4 pb-4">
                      <b-input
                            type="text"
                            class="form-control text-dark font-size-16 font-weight-normal bg-white"
                            style="height:33px;"  @keyup.native.enter="addRequestAvoirLine()"
                            placeholder="Motif de la demande"
                            v-model="selectedItem.reason"
                            
                            />
                  </td>


                  <td class="text-center text-right pt-4 pb-4">
                    <div  >

                      <i class="fas fa-plus-square font-size-22 text-primary align-middle pl-3 pt-2" @click="addRequestAvoirLine()" style="cursor:pointer ;" ></i>

                        <!-- <b-button variant="outline-primary" @click="addRequestAvoirLine()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="isAddRequestLineEnabled">
                               <i class=" fas fa-plus-square font-size-16 font-weight-bold align-middle "></i> Ajouter
                        </b-button> -->
                    </div>             
                </td> 
                  

              </tr>



              <tr v-for="(line,i) in this.avoirLines" :key="i">
                  <td class=" text-left pl-4">
                    <div class="font-weight-bold text-dark font-size-14 ">{{line.itemTitle}}</div>
                    <span class="font-size-12"> Réf: {{ line.itemRef }}</span>
                  </td> 

                  <td class=" text-left text-dark font-size-16 pl-3">{{ line.batchNumber }}</td>  
                <td class=" text-left text-dark font-size-16 pl-3">{{ line.batchDate }}</td>  
                  
                  <td class=" text-left text-dark font-size-16 pl-3">{{ line.quantityAvoir }}</td>  
                  
                  <td class=" text-left text-dark font-size-14 pl-3">{{ line.reason }}</td> 
                  
                <!-- <td v-if="role===1 " class="text-left font-size-16 pr-4">
                  <div class="pl-4 pr-4">
                    <b-input
                      :id="'quantityInput_' + i"  
                      type="number"
                      class="form-control text-dark font-size-16 font-weight-normal bg-white w-10"
                      v-model="line.confirmedQuantityAvoir"
                      :max="line.quantityAvoir"
                      :min="0"
                    />
                  </div>
                </td>  -->

                

                <!-- <td v-if="role==0 &&  (avoir.status==2 ||avoir.status==3) "  class="text-left font-size-16 pr-4" > {{ line.confirmedQuantityAvoir }} </td>               -->
                    <td v-if="role==0  && (avoir.status==0)" class=" text-center">
                      <i class="mdi mdi-trash-can font-size-22 align-middle text-danger" style="cursor: pointer;" @click="removeAvoirLine(line)"></i>
                  </td>
                </tr>


              </tbody>

              </table>
              </div>
























            
      
      

        <div class="row mt-4 ml-4 d-print-none" >
            <div class="col-md-6 col-sm-12 "/>
            <div class="col-md-6 col-sm-12 d-print-none pr-0 text-right ">
                <!-- <b-button variant="light" class="m-2"  size="lg" @click="onCloseAddNewAvoirModal"  >
                  <span class="font-weight-bold font-size-16"> {{$t('avoir.newAvoir.modal.cancelButton')}}</span>
                </b-button> -->
                <!-- <b-button variant="danger" class="m-2" v-if=" !isNew && (avoir.status==2 || (role==1 && avoir.status!=3))" size="lg"  @click="refusedAvoirRequest"   >
                  <span class="font-weight-bold font-size-16"> {{$t('avoir.newAvoir.modal.refusedButton')}}</span>
                </b-button> -->

                <a href="javascript:void(0)"  @click="handlePrint" class="mr-3 ml-3" v-if="avoir && avoir.status">
                  <b-button variant="outline-secondary" >
                    <i class="fa fa-print font-size-14 align-middle mr-lg-2"></i> <span class="d-none d-lg-inline">{{$t("order.buttons.print")}}   </span>
                  </b-button>
                </a>
                
                <b-button variant="success"  @click="sendNewAvoir"  v-if="role==0 && avoir && avoir.status === 0" >
                    <i class="fas fa-paper-plane font-size-14 font-weight-bold align-middle mr-2"></i> <span class="font-weight-bold font-size-14">Envoyer la demande</span>
                </b-button> 
                
                <b-button variant="success"    @click="validateRequest"  v-if="role==1 && avoir && avoir.status != 2" >
                    <i class="fas fa-paper-plane font-size-14 font-weight-bold align-middle mr-2"></i> <span class="font-weight-bold font-size-14">Cloturer</span>
                </b-button>
            </div>
        </div> 


<!-- end table-->











        <!--      item modal
 -->    
 <b-modal v-model="showItemsModal" 
      title="Liste des Articles" 
      centered no-footer
      title-tag="h5"
      header-close-variant="danger"
      title-class="text-warning"
      size="xl">
        <div class=" zoom-container">


          <b-input-group  >
            <b-form-input placeholder="Chercher par Référence ou Désignation ou Marque"  v-model="itemsFilter"   @keyup.native.enter="findItems()"
                ></b-form-input>                              
            <template v-slot:append>
                <b-button variant="success" @click="findItems()">
                <i class="bx bx-search-alt font-size-16 align-middle"></i>
                </b-button>
            </template>
          </b-input-group>


          <div class="col">
          <b-table
            :striped="true"
            :small="true"
            :hover="true"
            :items="itemLines"
            :fields="itemFields"
            :busy="isItemsTableBusy"
            
            responsive
            class="col-12 p-3"
          > 
          <template v-slot:cell(actions)="{item}">
              <a  title="Ajouter" href="javascript:void(0);"  @click="addItems(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-primary">
                <i class="fas fa-plus-circle font-size-18" />
              </a>  
        </template>
                             
        </b-table>
        <span v-if="!isItemsTableBusy && !itemLines.length" class="d-flex justify-content-center mr-4 ml-4 mt-4 mb-4 text-danger" >{{ $t("catalog.empty") }} </span>

        <!--Pagination-->         
            <div class="col-12">
                  <div class="row">
                    <div class="col-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="findItems()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodelMain.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findItems()" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                  </div>
              </div> 
          <!--Fin Pagination-->         
        </div>

      </div>

        <template v-slot:modal-footer>
          <b-button class="zoom-container" variant="secondary" @click="showItemsModal=false" size="md">Annuler</b-button>
        </template> 
      </b-modal>









        </b-modal>










</template>


<style>

@media print {
  .modal-header {
      display: none !important;
  }
  
}

</style>
